import { render } from "./Tasks.vue?vue&type=template&id=7e383452"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__